import React from 'react'
import '../customers/customers.css';
import about1 from "../../img/about1.png";

function customers() {
  return (
     <section className="hero d-flex align-items-center">
    <div className="container">
      <div className="row align-items-center">
        
    
        <div className="col-lg-6 text-center mb-4 mb-lg-0">
          <img src={about1} alt="Food" className="img-fluid hero-img"/>
        </div>

        
        <div className="col-lg-6 text-center text-lg-start text-white">
          <h5 className=" fw-bolder" style={{color:'#cf6511'}}>FROM OUR CUSTOMERS</h5>
          <h1 className="fw-bold display-5">THE BEST<br/>RATED FOOD</h1>
          <p className="lead">
            Indulge in the best dining experience of Indian, International, Italian, 
            Continental, Northeast and Asian Cuisine in Bengaluru.
          </p>
          {/* <a href="#" class="btn btn-warning btn-lg mt-3 text-white" style={{background:'#c11212', borderBlockColor:'#c11212' }}>VIEW MORE</a> */}
        </div>

      </div>
    </div>
  </section>
  )
}

export default customers
